import { gql } from "@apollo/client"

const PROCESS_JOB_STEP_FIELDS = gql`
  fragment ProcessJobStepFields on ProcessJobStep {
    id
    step
    number
    section
    name
    job {
      id
      process
      title
      percentComplete
      completed @client
      totalSteps
      completedSteps
      score
      possibleScore
      notes
      unresolvedActions
    }
    score
    possibleScore
    failed
    description
    responseType
    responseMandatory
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    notes {
      ...JobStepNotesFields
    }
    repeatable
  }
`

export { PROCESS_JOB_STEP_FIELDS }
